var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDoodle5 = function SvgDoodle5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 45,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doodle5_svg__clip0_1338_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.76 29.842c-3.158 2.873-6.982 5.728-11.37 6.165-3.426.338-6.603-.963-9.457-2.738-3.453-2.141-6.514-4.867-9.64-7.446-3.82-3.152-7.74-6.22-11.993-8.773-5.585-3.352-11.691-5.713-18.108-6.884-1.42-.26-1.89 1.94-.462 2.203 5.967 1.085 11.616 3.222 16.846 6.28 4.387 2.554 8.382 5.694 12.287 8.922 5.662 4.686 12.258 11.25 20.234 10.727 5.17-.338 9.61-3.54 13.311-6.919 1.077-.975-.59-2.498-1.653-1.528l.004-.009z",
    fill: "#F05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "doodle5_svg__clip0_1338_894"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(27.278 3.772 15.547)",
    d: "M0 0h65.89v15.75H0z"
  })))));
};
export default SvgDoodle5;